import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { ProductType } from './config/product-type';
import StatusTypeConfig from './config/status-type';
import * as uuid from 'uuid';

export interface FILTER {
  label: string
  field: string
  value: string
  enabled: boolean
}

export class Commons {
  static readonly SDX = 'Softdirex'
  static readonly SESSION_KEY = 'cus_S'
  static readonly DF_AVATAR = './assets/img/png/df_avatar.png'
  static readonly DF_AVATAR_STORAGE = 'df_avatar.png'
  static readonly DF_COMPANY_LOGO = './assets/img/png/company_logo_df.png'
  static readonly NO_IMAGE = './assets/img/png/no_image.png'
  static readonly PATH_MAIN = 'store'
  static readonly PATH_SALES_REPORT = 'sales-report'
  static readonly PATH_PUBLIC_PRODUCT = this.PATH_MAIN + '/product'
  static readonly PATH_PRODUCTS = 'products'
  static readonly PATH_PRODUCTS_EDIT = this.PATH_PRODUCTS + '/edit'
  static readonly PATH_PRODUCTS_CREATE = this.PATH_PRODUCTS + '/add'
  static readonly PATH_PLANS = 'plans'
  static readonly PATH_PLANS_EDIT = this.PATH_PLANS + '/edit'
  static readonly PATH_PLANS_CREATE = this.PATH_PLANS + '/add'
  static readonly PATH_CUSTOMERS = 'customers'
  static readonly PATH_CUSTOMERS_EDIT = this.PATH_CUSTOMERS + '/edit'
  static readonly PATH_CUSTOMERS_CREATE = this.PATH_CUSTOMERS + '/add'
  static readonly PATH_COMPANIES = 'companies'
  static readonly PATH_COMPANIES_EDIT = this.PATH_COMPANIES + '/edit'
  static readonly PATH_COMPANIES_CREATE = this.PATH_COMPANIES + '/add'
  static readonly PATH_LICENCES = 'licences'
  static readonly PATH_LICENCES_EDIT = this.PATH_LICENCES + '/edit'
  static readonly PATH_LICENCES_CREATE = this.PATH_LICENCES + '/add'
  static readonly PATH_INTEGRATIONS = 'integrations'
  static readonly PATH_API_KEYS = 'integrations/api-keys'
  static readonly PATH_API_KEYS_CREATE = 'integrations/api-keys/add'
  static readonly PATH_API_KEYS_EDIT = 'integrations/api-keys/edit'

  static readonly PATH_MY_COMPANY = 'organization'
  static readonly PATH_MY_COMPANY_MEMBERS_CREATE = this.PATH_MY_COMPANY + '/add'
  static readonly PATH_MY_COMPANY_MEMBERS_EDIT = this.PATH_MY_COMPANY + '/edit'
  static readonly PATH_MY_PURCHASES = 'payment-history'
  static readonly PATH_MY_LICENCES = 'subscriptions'
  static readonly PATH_MY_CUSTOMER = 'user-profile'

  static readonly PATH_LOGIN = 'login'
  static readonly PATH_REGISTER = 'register'
  static readonly PATH_PWD_REC = 'password-recovery'
  static readonly PATH_PWD_CHN = 'change-password'
  static readonly PATH_MAIL_VER = 'verify-mail'
  static readonly PATH_PURCHASE = 'payment'
  static readonly PATH_PURCHASE_DETAIL = 'payment-detail'
  static readonly PATH_TERMS = 'terms'
  static readonly PATH_SUPPORT = 'support'
  static readonly PATH_ABOUT = 'about-us'
  static readonly PATH_PDF_VIEWER = 'pdf-viewer'
  static readonly PATH_UF_CONVERTER = 'uf-converter'

  // https://docs.google.com/spreadsheets/d/1Ibr_vxVzMILFJXGrDlIummIkQ11mSYCQT5j5dNT8R3o/edit#gid=0
  static readonly USER_TYPE_BASIC = 'CLI'
  static readonly USER_TYPE_MEDIUM = 'USU'
  static readonly USER_TYPE_APP = 'APP'

  static readonly USER_TYPES: any[] = [
    { value: this.USER_TYPE_BASIC, name: 'label.client' },
    { value: this.USER_TYPE_MEDIUM, name: 'label.user' },
    { value: this.USER_TYPE_APP, name: 'label.app' }
  ]

  static getCusType(arg: string) {
    var item = this.USER_TYPES.find(item => item.value === arg.toUpperCase())
    if (item === undefined) {
      return this.USER_TYPES[0].name
    } else {
      return item.name
    }
  }
  // CUSTOMER's rols
  static readonly USER_ROL_BASIC = 'V'
  static readonly USER_ROL_RW = 'RW'
  static readonly USER_ROL_RWX = 'RWX'
  // ADMIN's rols
  static readonly USER_ROL_S_RW = 'S_RW'
  static readonly USER_ROL_S_RWX = 'S_RWX'

  static readonly USER_ROLES: any[] = [
    { value: this.USER_ROL_BASIC, name: 'label.rol-v-name' },
    { value: this.USER_ROL_RW, name: 'label.rol-rw-name' },
    { value: this.USER_ROL_RWX, name: 'label.rol-rwx-name' },
    { value: this.USER_ROL_S_RW, name: 'label.rol-srw-name' },
    { value: this.USER_ROL_S_RWX, name: 'label.rol-srwx-name' }
  ]

  static readonly USER_USU_ROLES: any[] = [
    { value: this.USER_ROL_BASIC, name: 'label.rol-v-name' },
    { value: this.USER_ROL_RW, name: 'label.rol-rw-name' },
    { value: this.USER_ROL_RWX, name: 'label.rol-rwx-name' }
  ]

  static getCusRol(arg: string) {
    var item = this.USER_ROLES.find(item => item.value === arg.toUpperCase())
    if (item === undefined) {
      return this.USER_ROLES[0].name
    } else {
      return item.name
    }
  }

  static readonly STATUS_DELETED_INACTIVE = StatusTypeConfig.DELETED_INACTIVE.id
  static readonly STATUS_DELETED_ACTIVE = StatusTypeConfig.DELETED_ACTIVE.id
  static readonly STATUS_ACTIVE = StatusTypeConfig.ACTIVE.id
  static readonly STATUS_INACTIVE = StatusTypeConfig.INACTIVE.id
  static readonly STATUS_IN_PROCESS = StatusTypeConfig.IN_PROCESS.id

  static readonly MAX_COUNTRIES = 251
  static readonly MOBILE_WIDTH = 600

  static readonly ICON_ERROR = 'error'
  static readonly ICON_WARNING = 'warning'
  static readonly ICON_SUCCESS = 'success'
  static readonly ICON_INFO = 'info'

  static readonly CONFIRM = true
  static readonly CANCEL = false
  static readonly IS_BASIC_AUTH = true

  static readonly TERM_CODES = [
    {
      id: 1,
      code: 'privacy-policy'
    },
    {
      id: 2,
      code: 'terms-conditions'
    },
    {
      id: 3,
      code: 'terms-sales'
    },
    {
      id: 5,
      code: 'cookie-policy'
    }
  ]

  static readonly DOCUMENT_DATA_TYPES: any[] = [
    { value: 'PASSPORT', name: 'personal-data.passport' },
    { value: 'DNI', name: 'personal-data.dni' },
    { value: 'RUT', name: 'personal-data.rut' }
  ]

  static readonly GENDER_TYPES: any[] = [
    { value: '0', name: 'personal-data.sex-0' },
    { value: '1', name: 'personal-data.sex-1' },
    { value: '2', name: 'personal-data.sex-2' },
    { value: '3', name: 'personal-data.sex-3' }
  ]

  static readonly PROVINCE_TYPES: any[] = [
    { value: 'province', name: 'personal-data.province-1' },
    { value: 'state', name: 'personal-data.province-2' },
    { value: 'commune', name: 'personal-data.province-3' }
  ]

  static readonly CONTACT_DATAS: any[] = [
    { label: 'label.personal-email', field: 'MAIL', value: '', enabled: false },
    { label: 'label.phone1', field: 'PHONE', value: '', enabled: false },
    { label: 'label.secondary-email', field: 'MAIL_2', value: '', enabled: false },
    { label: 'label.secondary-phone', field: 'PHONE_2', value: '', enabled: false },
    { label: 'label.twitter', field: 'TWITTER', value: '', enabled: false },
    { label: 'label.facebook', field: 'FACEBOOK', value: '', enabled: false },
    { label: 'label.instagram', field: 'INSTAGRAM', value: '', enabled: false },
    { label: 'label.reddit', field: 'REDDIT', value: '', enabled: false },
    { label: 'label.linkedin', field: 'LINKEDIN', value: '', enabled: false },
    { label: 'label.youtube', field: 'YOUTUBE', value: '', enabled: false },
    { label: 'label.pinterest', field: 'PINTEREST', value: '', enabled: false },
  ]

  static readonly CURRENCIES: string[] = ['UF', 'CLP']

  static readonly PLAN_TYPES: any[] = [
    { value: "-1", name: 'label.wrong-type' },
    { value: "1", name: 'label.monthly-plan' },
    { value: "2", name: 'label.bi-monthly-plan' },
    { value: "3", name: 'label.quarterly-plan' },
    { value: "6", name: 'label.half-year-plan' },
    { value: "12", name: 'label.annual-plan' },
    { value: "24", name: 'label.biannual-plan' },
    { value: "36", name: 'label.triple-year-plan' }
  ]

  static readonly PAYMENT_TYPES: any[] = [
    { value: 0, name: 'label.paymenttype-other' },
    { value: 1, name: 'label.paymenttype-pay-online' },
    { value: 2, name: 'label.paymenttype-cash' },
    { value: 3, name: 'label.paymenttype-wire-transfer' },
    { value: 4, name: 'label.paymenttype-check' }
  ]

  static readonly PRODUCT_TYPES: any[] = [
    { value: 0, name: 'label.unknown-product-type' },
    { value: 1, name: 'label.web-product-type' },
    { value: 2, name: 'label.desktop-product-type' },
    { value: 3, name: 'label.mobile-product-type' }
  ]

  static readonly API_KEY_FLOWS: any[] = [
    { value: 'PRD', name: 'label.flow-prd' },
    { value: 'PLN', name: 'label.flow-pln' },
    { value: 'LIC', name: 'label.flow-lic' },
    { value: 'PDA', name: 'label.flow-pda' },
    { value: 'CUS', name: 'label.flow-cus' },
    { value: 'CIA', name: 'label.flow-cia' },
    { value: 'CBC', name: 'label.flow-cbc' },
    { value: 'CNT', name: 'label.flow-cnt' },
    { value: 'CUR', name: 'label.flow-cur' },
    { value: 'MY_PDA', name: 'label.flow-my-pda' },
    { value: 'MY_CUS', name: 'label.flow-my-cus' },
    { value: 'MY_CIA', name: 'label.flow-my-cia' },
    { value: 'MY_LIC', name: 'label.flow-my-lic' },
    { value: 'PAY', name: 'label.flow-pay' },
    { value: 'API_KEY', name: 'label.flow-api-key' }
  ]

  static readonly TRIAL_CATEGORY = 'TRIAL'
  static readonly BASIC_CATEGORY = 'BASIC'
  static readonly MEDIUM_CATEGORY = 'MEDIUM'
  static readonly PREMIUM_CATEGORY = 'PREMIUM'

  static readonly PLAN_CATEGORIES: any[] = [
    { value: this.TRIAL_CATEGORY, name: 'label.trial-plan', icon: 'sdx sdx-flask' },
    { value: this.BASIC_CATEGORY, name: 'label.basic-plan', icon: 'sdx sdx-bookmark' },
    { value: this.MEDIUM_CATEGORY, name: 'label.medium-plan', icon: 'sdx sdx-certificate' },
    { value: this.PREMIUM_CATEGORY, name: 'label.premium-plan', icon: 'sdx sdx-award' }
  ]

  static validField(arg: any) {
    return arg !== null && arg !== undefined
  }

  /**
   * Encrypt json object
   * @param jsonData
   * @returns
   */
  static encryptDataLocal(jsonData: any) {
    if (this.validField(jsonData)) {
      return CryptoJS.AES.encrypt(JSON.stringify(jsonData), environment.localeKey).toString();
    }
    return ''
  }

  /**
   * Encrypt string value
   * @param stringData
   * @returns
   */
  static encryptString(stringData: any): string {
    if (this.validField(stringData)) {
      try {
        return window.btoa(window.btoa(stringData))
      } catch (error) {
        return '-'
      }

    }
    return ''
  }

  /**
   * Decrypt json object
   * @param encryptedData
   * @returns
   */
  static decryptDataLocal(encryptedData: string): any {
    if (this.validField(encryptedData)) {
      var bytes = CryptoJS.AES.decrypt(encryptedData, environment.localeKey);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
    return null
  }

  /**
   * Decrypt string value
   * @param encryptedString
   * @returns
   */
  static decryptString(encryptedString: string): any {
    if (this.validField(encryptedString)) {
      try {
        return window.atob((window.atob(encryptedString)))
      } catch (error) {
        return '-'
      }

    }
    return '-'
  }

  /**
   * Return the traductor field for product type
   * @param id
   * @returns
   */
  static getProductType(id: any): string {
    return ProductType.getType(id)
  }

  static sessionOpenCustomer(customer: any, credentials: string, isBasicAuth: boolean) {
    const now: Date = new Date()
    const sessionSign = {
      customer: customer,
      key: ((isBasicAuth) ? 'Basic ' : 'Bearer ') + credentials,
      time: now.getTime()
    }
    localStorage.setItem(this.SESSION_KEY, this.encryptDataLocal(sessionSign))
  }

  static sessionReloadCustomer(customer: any) {
    const now: Date = new Date()
    var sessionSign = this.decryptDataLocal(localStorage.getItem(this.SESSION_KEY)!)
    sessionSign.customer.personal_data = customer.personal_data
    sessionSign.customer.avatar = customer.avatar
    if (this.validField(customer.type)) {
      sessionSign.customer.type = customer.type
    }
    if (this.validField(customer.rol)) {
      sessionSign.customer.rol = customer.rol
    }
    if (this.validField(customer.company)) {
      sessionSign.customer.company = customer.company
    }
    sessionSign.time = now.getTime()
    localStorage.setItem(this.SESSION_KEY, this.encryptDataLocal(sessionSign))
  }

  static sessionIsOpen(): boolean {
    return this.decryptDataLocal(localStorage.getItem(this.SESSION_KEY)!) !== null
  }

  /**
   * Load a session from external url access with token
   * @param externalToken
   * @returns
   */
  static withouthSessionAndExternalTokenValid(externalToken: any): boolean {
    return (this.validField(externalToken) && !this.sessionIsOpen())
  }

  static sessionRenew() {
    const now: Date = new Date()
    const sessionSign: any = this.decryptDataLocal(localStorage.getItem(this.SESSION_KEY)!)

    if (sessionSign !== null) {
      // renew session time
      sessionSign.time = now.getTime()
      localStorage.setItem(this.SESSION_KEY, this.encryptDataLocal(sessionSign))
    }
  }

  static sessionClose() {
    localStorage.removeItem(this.SESSION_KEY)
  }

  static sessionObject(): any {
    return this.decryptDataLocal(localStorage.getItem(this.SESSION_KEY)!)
  }

  static sessionIsSuperUser(): any {
    var isSuper: boolean = false
    const sessionSign: any = this.decryptDataLocal(localStorage.getItem(this.SESSION_KEY)!)

    if (sessionSign !== null && this.validField(sessionSign.customer.rol)) {
      isSuper = (sessionSign.customer.rol === this.USER_ROL_S_RW || sessionSign.customer.rol === this.USER_ROL_S_RWX)
    }
    return isSuper
  }

  static sessionRol(): string {
    var rol: string = this.USER_ROL_BASIC
    const sessionSign: any = this.decryptDataLocal(localStorage.getItem(this.SESSION_KEY)!)

    if (sessionSign !== null && this.validField(sessionSign.customer.rol)) {
      rol = sessionSign.customer.rol
    }
    return rol
  }

  static sessionCredentials(): string {
    var credentials: string = ''
    const sessionSign: any = this.decryptDataLocal(localStorage.getItem(this.SESSION_KEY)!)

    if (sessionSign !== null && this.validField(sessionSign.key)) {
      credentials = sessionSign.key
    }
    return credentials
  }

  static isGAuthCredentials(): boolean {
    let cred = this.sessionCredentials()
    return (this.validField(cred) && cred.startsWith('Bearer'))
  }

  /**
   *
   * @returns a 11 characters of password with sdx in end for backend validation
   */
  static createPasswordForUser(): string {
    const pwd = uuid.v4();
    return pwd.substring(0, 8).toLowerCase() + 'sdx'
  }

  static validNumber(str: string): boolean {
    if (this.validField(str)) {
      if (typeof str !== 'string') {
        return false;
      }
      if (str.trim() === '') {
        return false;
      }
      return !Number.isNaN(Number(str));
    }
    return false
  }
}
